import React from 'react'
import { CardActions, CardContent, Divider, Typography } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import jMoment from 'moment-jalaali';
import RonadIcons from '../iconComponent';
const useStyles = makeStyles(theme =>
  createStyles({
    adminCard: {
      width: '50%',
      boxShadow: 'none !important',
      marginBottom: '8px',
      borderRadius: '10px',
      backgroundColor: "#2F4858",
      color: "#fff",
      justifySelf: "end",
      borderTopRightRadius: "0px",
    },
    userCard: {
      width: '50%',
      boxShadow: 'none !important',
      border: '1px solid lightgray',
      marginBottom: '8px',
      borderRadius: '10px',
      backgroundColor: "#fff",
      borderTopLeftRadius: "0px",
    },
    container: {
      display: "grid",
      width: "100%",
    },
    userName: {
      margin: "5px",
      fontWeight: 700
    },
    adminUserName: {
      margin: "5px",
      fontWeight: 700,
      textAlign: "right"
    },
    adminDate: {
      textAlign: "right"
    }
  })
);

type Data = {
  id: number
  body: string
  status: string
  user: object
  createdAt: string
  updatedAt: string
  attachments?: string[]
}

const TicketCards = ({data}: {data: Data}) => {
  const {id, body, status, user,createdAt, updatedAt, attachments} = data
  const classes = useStyles();


  return (
    <div className={classes.container}>
      <Typography className={user.type === 'PARTNER' ? classes.userName : classes.adminUserName}>
        {user?.username}
      </Typography>
      <Card className={user.type === 'PARTNER' ? classes.userCard : classes.adminCard}>
        <CardContent style={{ padding: '16px' }}>
          <Typography>
            {body}
          </Typography>
        </CardContent>
        {/* {attachments.length > 0 &&
          <>
            <Divider />
            <CardActions>
              <Typography>

                {
                  attachments.map((item) => {
                    return (
                      <>
                        <a style={{ textDecoration: 'none' }} target="_blank" href={`${item}`}  >{item.split('/').pop()}</a>
                        <RonadIcons name='fileShare' size={0.8} style={{ marginLeft: '8px' }} />
                      </>
                    )
                  })
                }
              </Typography>
            </CardActions>
          </>
        } */}
      </Card>
      <Typography className={user.type !== 'PARTNER' && classes.adminDate}>
        {jMoment(createdAt, 'YYYY-M-D HH:mm')
          .locale('fa')
          .format('HH:mm jYYYY/jMM/jDD ')}
      </Typography>
    </div>
  )
}

export default TicketCards
